import styled from "styled-components";

export const Loading = styled.div`
  background: #000000;
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100vh;
  justify-content: center;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999 !important;

  /* .loader {
    animation: none !important;
    border: none !important;
  } */

  .circle {
    animation: animate 2s infinite linear;
    background: #ffffff;
    border-radius: 50%;
    height: 1.25rem;
    margin: 0 0.25rem;
    width: 1.25rem;
    z-index: 1;
  }
  .circle:nth-child(1) {
    animation-delay: 0.5s;
  }
  .circle:nth-child(2) {
    animation-delay: 1s;
  }
  .circle:nth-child(3) {
    animation-delay: 1.5s;
  }

  @keyframes animate {
    0%,
    100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }
`;
